var _g, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSol(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 107,
    height: 107,
    viewBox: "0 0 107 107",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2_233)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 16.1566,
    y: 12.2493,
    width: 74.55,
    height: 74.55,
    rx: 37.275,
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2_233)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.1907 59.4467C38.4631 59.1718 38.8378 59.0115 39.2351 59.0115H75.2689C75.9273 59.0115 76.2565 59.8132 75.7911 60.2828L68.6729 67.464C68.4004 67.7389 68.0258 67.8993 67.6284 67.8993H31.5947C30.9363 67.8993 30.607 67.0975 31.0725 66.6279L38.1907 59.4467Z",
    fill: "url(#paint0_linear_2_233)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.1907 32.6344C38.4745 32.3596 38.8491 32.1992 39.2351 32.1992H75.2689C75.9273 32.1992 76.2565 33.001 75.7911 33.4705L68.6729 40.6518C68.4004 40.9266 68.0258 41.087 67.6284 41.087H31.5947C30.9363 41.087 30.607 40.2853 31.0725 39.8157L38.1907 32.6344Z",
    fill: "url(#paint1_linear_2_233)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.6729 45.9546C68.4004 45.6798 68.0258 45.5194 67.6284 45.5194H31.5947C30.9363 45.5194 30.607 46.3211 31.0725 46.7907L38.1907 53.972C38.4631 54.2468 38.8378 54.4072 39.2351 54.4072H75.2689C75.9273 54.4072 76.2565 53.6055 75.7911 53.1359L68.6729 45.9546Z",
    fill: "url(#paint2_linear_2_233)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2_233",
    x: 0.406616,
    y: 0.699267,
    width: 106.05,
    height: 106.05,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4.2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.875
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2_233"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2_233",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2_233",
    x1: 71.8266,
    y1: 27.9094,
    x2: 46.5411,
    y2: 75.9162,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00FFA3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DC1FFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2_233",
    x1: 60.9222,
    y1: 22.1659,
    x2: 35.6367,
    y2: 70.1727,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00FFA3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DC1FFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2_233",
    x1: 66.3397,
    y1: 25.0193,
    x2: 41.0542,
    y2: 73.0261,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00FFA3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DC1FFF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2_233"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 45.15,
    height: 35.7,
    fill: "white",
    transform: "translate(30.8563 32.1992)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSol);
export default __webpack_public_path__ + "static/media/sol.850bf091bbc4db94ae69efc962f62344.svg";
export { ForwardRef as ReactComponent };